module.exports = __webpack_public_path__ + "static/media/record.d18cea18.png";